import React, { useState, useCallback } from 'react'
import { FaImage, FaSpinner } from 'react-icons/fa'
import { IconTooltip } from '../Tooltip'
import toast from '../Toast'
import dayjs from 'dayjs'
import html2canvas from 'html2canvas'

const SaveAsImageButton = ({
    name,
    componentRef,
    customOnClickAction = null,
    pending = false,
    disabled = false,
    disabledMessage = null,
}) => {
    const [downloadingImage, setDownloadingImage] = useState(false)
    const truePending = pending || downloadingImage

    const saveAsImage = useCallback(async () => {
        if (!componentRef || !componentRef.current) {
            return null
        }

        // let chartSVG = ReactDOM.findDOMNode(currentChart).children[0]
        // let svgURL = new XMLSerializer().serializeToString(chartSVG);
        // let svgBlob = new Blob([svgURL], {type: "image/svg+xml;charset=utf-8"});
        
        setDownloadingImage(true)
        const chartCanvas = await html2canvas(componentRef.current, {
            useCORS: true,
        })

        const url = chartCanvas.toDataURL('image/png')
        const link = document.createElement('a')
        link.href = url
        link.download = `NE_Clearinghouse_${name}_${dayjs().format(
            'MM-DD-YYYY'
        )}.png`
        document.body.appendChild(link)
        link.click()

        // Clean up
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        setDownloadingImage(false)
    }, [componentRef, name])

    return (
        <div
            className={`panelHeaderIconDiv displayIcon ${
                disabled ? 'disabled-link' : ''
            }`}
            data-for={`${name}-save-as-image-${truePending}`}
            data-tip={`Save as Image`}
            onClick={e => {
                if (disabled && !downloadingImage) {
                    toast({
                        level: 'info',
                        message:
                            disabledMessage ||
                            'If you wish to save the chart as an image, please generate the chart.',
                        alert: true,
                    })
                    return
                }
                (customOnClickAction && customOnClickAction()) || saveAsImage()
            }}
        >
            {truePending ? <FaSpinner className="fa-pulse" /> : <FaImage />}
            <IconTooltip id={`${name}-save-as-image-${truePending}`} />
        </div>
    )
}

export default SaveAsImageButton
